/* eslint-disable no-console */
import Vue from 'vue'
import Skycon from '@/components/Skycon/Skycon'
import { Chrome } from 'vue-color'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import Axios from 'axios'
import config from '../../../config'
const ENDPOINT = config.webprofileApiUrl

export default {
  name: 'about',
  components: {
    Skycon,
    Chrome,
    vSelect,
    DatePicker,
  },
  data() {
    return {
      color: {
        hex: '#cccccc',
      },
      title: null,
      content: null,
      isLoading: false,

      isPickerActive: false,
      intPhoneModel: null,
      datepickerText: '',
      defaultSelect: 'Andromeda Galaxy',
      fontAwesomeCode:
        '<i class="fa fa-arrow-left fa-2x me-0"></i>\n' +
        '<i class="fa fa-github fa-2x me-0"></i>\n' +
        '<i class="fa fa-bath fa-2x me-0"></i>\n' +
        '<i class="fa fa-grav fa-2x me-0"></i>\n' +
        '<i class="fa fa-telegram fa-2x"></i>',
      glyphiconCode:
        '<i class="glyphicon glyphicon-asterisk me-0"></i>\n' +
        '<i class="glyphicon glyphicon-heart me-0"></i>\n' +
        '<i class="glyphicon glyphicon-home me-0"></i>\n' +
        '<i class="glyphicon glyphicon-refresh me-0"></i>\n' +
        '<i class="glyphicon glyphicon-camera"></i>',
      lineAwesomeCode:
        '<i class="la la-arrow-left la-2x me-0"></i>\n' +
        '<i class="la la-github la-2x me-0"></i>\n' +
        '<i class="la la-facebook la-2x me-0"></i>',
      vueColorCode:
        '<b-input-group class="colorpicker-wrapper">\n' +
        '  <input type="text" class="form-control" :value="color.hex"/>\n' +
        '  <Chrome\n' +
        '      :class="{ colorpicker: true, \'d-none\': !isPickerActive }"\n' +
        '      v-model="color"\n' +
        '  />\n' +
        '  <b-input-group-text @click="isPickerActive = !isPickerActive" slot="append">\n' +
        '    <div class="rect" :style="{ backgroundColor: color.hex }"></div>\n' +
        '  </b-input-group-text>\n' +
        '</b-input-group>',
      editorConfig: {
        image: false, // Menonaktifkan fungsi unggah gambar
      },
      editData: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    selectDate(val) {
      Vue.set(this, 'datepickerText', val.toLocaleDateString())
    },
    // get content
    async getData() {
      this.isLoading = true
      try {
        const AxiosResponse = await Axios.get(`${ENDPOINT}/company-profile/about`)
        const data = AxiosResponse.data.find((i) => i.id === 1)
        if (data) {
          this.content = data.body
          this.title = data.title
        }
      } catch (e) {
        this.$toasted.error('Gagal Memuat')
      } finally {
        this.isLoading = false
      }
    },

    // update content
    async updateData(id, payload) {
      this.isLoading = true
      try {
        const AxiosResponse = await Axios.patch(
          `${ENDPOINT}/company-profile/about/${id}`,
          { title: 'About', body: payload },
          {
            headers: { 'Content-Type': 'application/json' },
          },
        )

        this.$toasted.success('Berhasil Disimpan')

        return AxiosResponse.data
      } catch (e) {
        this.$toasted.error('Gagal Disimpan')
      } finally {
        this.isLoading = false
      }
    },

    async postData(payload) {
      this.isLoading = true
      try {
        const AxiosResponse = await Axios.post(`${ENDPOINT}/company-profile/about`, { title: 'About', body: payload })

        this.$toasted.success('Berhasil Disimpan')

        return AxiosResponse.data
      } catch (e) {
        this.$toasted.error('Gagal Disimpan')
      } finally {
        this.isLoading = false
      }
    },
    async saveMarkdown() {
      await this.updateData(1, this.content)
    },
  },
}
